import React, { FC } from 'react'

import styled from 'styled-components'

import { GenreWithCurators } from 'src/Redux/spotifyCampaignGenresApi'
import { LabelForGenreOrLanguage } from 'src/Components/LabelForGenreOrLanguage'
import { capitalizeWords } from 'src/Helpers/layoutHelpers'

type Props = {
  genres?: GenreWithCurators[]
  onClickGenre: (genre: GenreWithCurators) => void
}
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  position: sticky;
  top: 96px;
  background-color: ${({ theme }) => theme.color.white};
  padding-top: 8px;
  padding-bottom: 8px;
  z-index: 1;
`
const Title = styled.h3`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  width: 100%;
  margin: 0;
`
const List = styled.ul`
  display: flex;
  align-items: center;
  align-content: center;
  gap: 8px;
  align-self: stretch;
  flex-wrap: wrap;
  padding: 0px;
  margin: 0px;
`

export const SelectedGenresList: FC<Props> = ({ genres, onClickGenre }) => {
  if (!genres || genres.length === 0) {
    return null
  }
  return (
    <Container>
      <Title>Selected ({genres.length} of 5)</Title>
      <List>
        {genres.map((genre) => (
          <LabelForGenreOrLanguage
            key={genre.id}
            title={capitalizeWords(genre.genreName)}
            selected
            count={genre.curatorsCount}
            onClick={() => onClickGenre(genre)}
          />
        ))}
      </List>
    </Container>
  )
}
